import { getNodesByParam } from '@iebdc/utils/common';
import { addCookie } from '@iebdc/utils/cookies';
import store from '@iebdc/store';
export function getAreaCode() {
  console.log(JSON.parse(localStorage.getItem('finalAreaDataLocal')), 'fin');
  if (JSON.parse(localStorage.getItem('finalAreaDataLocal')) && JSON.parse(localStorage.getItem('ZWW_SXXX'))) {
    if (JSON.parse(localStorage.getItem('ZWW_SXXX')).areaCode) {
      let result = getNodesByParam(
        JSON.parse(localStorage.getItem('finalAreaDataLocal')),
        'code',
        JSON.parse(localStorage.getItem('ZWW_SXXX')).areaCode,
        'childrens'
      );
      console.log(result, 'finalArea');
      let nodes = [];
      let titles = [];
      let officeCode = '';
      let officeName = '';
      let jgmc = '';
      let djjg = '';
      result = result[0];
      console.log(result, 're');
      if (result.pids != null) {
        result.pids = result.pids.split(',')[0];
        let data = result.pids.split(',');
        //三级自动选择
        let node = '';
        let title = '';
        data.forEach((ele) => {
          node = getNodesByParam(JSON.parse(localStorage.getItem('finalAreaDataLocal')), 'id', ele, 'childrens')[0];
          title = getNodesByParam(JSON.parse(localStorage.getItem('finalAreaDataLocal')), 'id', ele, 'childrens')[0];
          nodes.push(node.code);
          titles.push(title.title);
        });
        nodes.push(result.childrens[0].code);
        titles.push(result.childrens[0].title);
        officeCode = result.childrens[0].bsdtData[0].officeCode;
        officeName = result.childrens[0].bsdtData[0].officeName;
        jgmc = result.childrens[0].bsdtData[0].jgmc;
        djjg = result.childrens[0].bsdtData[0].djjg;
        nodes.push(result.code);
        titles.push(result.title);
        console.log(data, result, nodes, titles, 'nt');
      }

      store.commit('dashboard/setSelectedShengCode', nodes[0]);
      store.commit('dashboard/setSelectedShengTitle', titles[0]);
      store.commit('dashboard/setSelectedShiCode', nodes[1]);
      store.commit('dashboard/setSelectedShiTitle', titles[1]);
      store.commit('dashboard/setSelectedAreaCode', nodes[2]);
      store.commit('dashboard/setSelectedAreaTitle', titles[2]);
      store.commit('dashboard/setSelectedBsdtCode', officeCode);
      store.commit('dashboard/setSelectedBsdtTitle', officeName);
      store.commit('dashboard/setSelectedOrganizationsCode', djjg);
      store.commit('dashboard/setSelectedOrganizationsTitle', jgmc);
      store.commit('dashboard/isShowBsdtDialog', false);
      addCookie('selectedBsdtTitle', store.state.dashboard.selectedBsdtTitle, 1);
      addCookie('selectedBsdtCode', store.state.dashboard.selectedBsdtCode, 1);
      addCookie('selectedOrganizationsTitle', store.state.dashboard.selectedOrganizationsTitle, 1);
      addCookie('selectedOrganizationsCode', store.state.dashboard.selectedOrganizationsCode, 1);
      addCookie('selectedShengTitle', store.state.dashboard.selectedShengTitle, 1);
      addCookie('selectedShengCode', store.state.dashboard.selectedShengCode, 1);
      addCookie('selectedShiTitle', store.state.dashboard.selectedShiTitle, 1);
      addCookie('selectedShiCode', store.state.dashboard.selectedShiCode, 1);
      addCookie('selectedAreaTitle', store.state.dashboard.selectedAreaTitle, 1);
      addCookie('selectedAreaCode', store.state.dashboard.selectedAreaCode, 1);
      // JSON.parse(localStorage.getItem('ZWW_SXXX')).areaCode = '';
    }
  } else if (JSON.parse(localStorage.getItem('finalAreaDataLocal')) && JSON.parse(localStorage.getItem('ZWW_fccx'))) {
    if (JSON.parse(localStorage.getItem('ZWW_fccx')).areaCode) {
      let result = getNodesByParam(
        JSON.parse(localStorage.getItem('finalAreaDataLocal')),
        'code',
        JSON.parse(localStorage.getItem('ZWW_fccx')).areaCode,
        'childrens'
      );
      console.log(result, 'finalArea');
      let nodes = [];
      let titles = [];
      let officeCode = '';
      let officeName = '';
      let jgmc = '';
      let djjg = '';
      result = result[0];
      console.log(result, 're');
      if (result.pids != null) {
        result.pids = result.pids.split(',')[0];
        let data = result.pids.split(',');
        //三级自动选择
        let node = '';
        let title = '';
        data.forEach((ele) => {
          node = getNodesByParam(JSON.parse(localStorage.getItem('finalAreaDataLocal')), 'id', ele, 'childrens')[0];
          title = getNodesByParam(JSON.parse(localStorage.getItem('finalAreaDataLocal')), 'id', ele, 'childrens')[0];
          nodes.push(node.code);
          titles.push(title.title);
        });
        nodes.push(result.childrens[0].code);
        titles.push(result.childrens[0].title);
        officeCode = result.childrens[0].bsdtData[0].officeCode;
        officeName = result.childrens[0].bsdtData[0].officeName;
        jgmc = result.childrens[0].bsdtData[0].jgmc;
        djjg = result.childrens[0].bsdtData[0].djjg;
        nodes.push(result.code);
        titles.push(result.title);
        console.log(data, result, nodes, titles, 'nt');
      }

      store.commit('dashboard/setSelectedShengCode', nodes[0]);
      store.commit('dashboard/setSelectedShengTitle', titles[0]);
      store.commit('dashboard/setSelectedShiCode', nodes[1]);
      store.commit('dashboard/setSelectedShiTitle', titles[1]);
      store.commit('dashboard/setSelectedAreaCode', nodes[2]);
      store.commit('dashboard/setSelectedAreaTitle', titles[2]);
      store.commit('dashboard/setSelectedBsdtCode', officeCode);
      store.commit('dashboard/setSelectedBsdtTitle', officeName);
      store.commit('dashboard/setSelectedOrganizationsCode', djjg);
      store.commit('dashboard/setSelectedOrganizationsTitle', jgmc);
      store.commit('dashboard/isShowBsdtDialog', false);
      addCookie('selectedBsdtTitle', store.state.dashboard.selectedBsdtTitle, 1);
      addCookie('selectedBsdtCode', store.state.dashboard.selectedBsdtCode, 1);
      addCookie('selectedOrganizationsTitle', store.state.dashboard.selectedOrganizationsTitle, 1);
      addCookie('selectedOrganizationsCode', store.state.dashboard.selectedOrganizationsCode, 1);
      addCookie('selectedShengTitle', store.state.dashboard.selectedShengTitle, 1);
      addCookie('selectedShengCode', store.state.dashboard.selectedShengCode, 1);
      addCookie('selectedShiTitle', store.state.dashboard.selectedShiTitle, 1);
      addCookie('selectedShiCode', store.state.dashboard.selectedShiCode, 1);
      addCookie('selectedAreaTitle', store.state.dashboard.selectedAreaTitle, 1);
      addCookie('selectedAreaCode', store.state.dashboard.selectedAreaCode, 1);
      // JSON.parse(localStorage.getItem('ZWW_SXXX')).areaCode = '';
    }
  }
}
